import { Service } from '@toeverything/infra';

import { FolderTree } from '../entities/folder-tree';
import type { FolderStore, FolderSubtreeNode } from '../stores/folder';

export class OrganizeService extends Service {
  constructor(private readonly folderStore: FolderStore) {
    super();
  }

  folderTree = this.framework.createEntity(FolderTree);

  /**
   * Collect all (unique) doc ids contained in a folder subtree.
   */
  collectDocIds(folderId: string): string[] {
    return this.folderStore.collectDocIds(folderId);
  }

  /**
   * Recursively duplicate a folder subtree under `targetParentId` (root when
   * null), remapping doc links through `docIdMap`.
   *
   * @returns the id of the new root folder copy
   */
  duplicateSubtree(
    sourceFolderId: string,
    targetParentId: string | null,
    docIdMap: ReadonlyMap<string, string>
  ): string {
    return this.folderStore.duplicateSubtree(
      sourceFolderId,
      targetParentId,
      docIdMap
    );
  }

  /**
   * Read a folder subtree into a serializable structure (for cross-workspace
   * copy).
   */
  exportSubtree(folderId: string): FolderSubtreeNode {
    return this.folderStore.exportSubtree(folderId);
  }

  /**
   * Write a previously exported subtree under `targetParentId`, remapping doc
   * links through `docIdMap`.
   */
  importSubtree(
    structure: FolderSubtreeNode,
    targetParentId: string | null,
    docIdMap: ReadonlyMap<string, string>
  ): string {
    return this.folderStore.importSubtree(structure, targetParentId, docIdMap);
  }
}
